import { memo, useEffect, useState } from "react"
import '../assets/css/Common.css'
import '../assets/css/Serials.css'
import { Skeleton } from "antd"
import { Helmet } from "react-helmet"
import { getSerials } from "../services/SerialsService"
import SerialCard from "../components/SerialCard"

const Serials = memo(function Serials() {
    const [serials, setSerials] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        let isMounted = true

        const fetchSerials = async () => {
            setLoading(true)
            setError(false)
            try {
                const data = await getSerials()
                if (isMounted) setSerials(data.content)
            } catch (err) {
                if (isMounted) setError(true)
            } finally {
                if (isMounted) setLoading(false)
            }
        }

        fetchSerials()

        return () => { isMounted = false }
    }, [])

    return (
        <div className="flex-container flex-column center-align serials-div">
            {!error ? (
                <>
                    {!loading && (
                        <Helmet>
                            <title>{"Historiografija.ba | Serijali"}</title>
                        </Helmet>
                    )}
                    {!loading ? (
                        <>
                            <h1 className="top-margin-5 font-weight-400 title-font-size">
                                Serijali članaka
                            </h1>
                            <p className="serials-intro">
                                Serijali predstavljaju tematske cjeline koje okupljaju srodne članke na jednom mjestu. Na ovom mjestu možete i Vi da objavite svoje radove, u skladu sa marketinškom politikom portala. Također se u više nastavaka mogu objaviti dijelovi neobjavljenih naučnih istraživanja ili dijelovi knjiga, što je posebno korisno za izdavače. Sponzori mogu predložiti teme ili ponuditi pripremljene radove, a objavljivanje će biti u skladu sa uredničkom politikom portala.
                            </p>
                        </>
                    ) : (
                        <div className="flex-container width-45p">
                            <Skeleton active paragraph={{ rows: 0 }} title={{ width: '100%' }} />
                        </div>
                    )}

                    {!loading ? (
                        <div className="serials-grid top-margin-5">
                            {serials.map((serial) => (
                                <div className="serials-grid-item" key={serial.id}>
                                    <SerialCard
                                        serialId={serial.id}
                                        title={serial.title}
                                        image={serial.image}
                                        url={serial.url}
                                        articleCount={serial.articleCount}
                                    />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="serials-grid top-margin-5">
                            {[...Array(3)].map((_, i) => (
                                <div className="serials-grid-item" key={i}>
                                    <Skeleton active paragraph={{ rows: 0 }} title={{ width: '100%' }} />
                                </div>
                            ))}
                        </div>
                    )}
                </>
            ) : (
                <div className="flex-container flex-wrap top-margin-5 center-justify full-width">
                    {[...Array(3)].map((_, i) => (
                        <div key={i} className="card" style={{ visibility: 'hidden' }} />
                    ))}
                </div>
            )}
        </div>
    )
})

export default Serials